import { render, staticRenderFns } from "./AllergensView.vue?vue&type=template&id=73c4a46a&scoped=true&"
import script from "./AllergensView.vue?vue&type=script&lang=ts&"
export * from "./AllergensView.vue?vue&type=script&lang=ts&"
import style0 from "./AllergensView.vue?vue&type=style&index=0&id=73c4a46a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73c4a46a",
  null
  
)

export default component.exports